// extracted by mini-css-extract-plugin
export default {"gridWrapper":"zegoGrid_gridWrapper__5cVum","double":"zegoGrid_double__S1uVd","three":"zegoGrid_three__pA+Ln","six":"zegoGrid_six__Obwd2"};